import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { OsaExecucaoCustoRecursoService } from './../../../../../services/osa-execucao-custo-recurso.service';
import { toFormatValue } from './../../../../../shared/util/toFormatValue';
import Swal from 'sweetalert2';
import { BaseFormComponent } from './../../../../../shared/components/base-form/base-form.component';
import { CustoRecursoService } from './../../../../../services/custo-recurso.service';

@Component({
  selector: 'app-osa-execucao-aba-custos-recursos-outros-custos-form-modal',
  templateUrl: './osa-execucao-aba-custos-recursos-outros-custos-form-modal.component.html',
  styleUrls: ['./osa-execucao-aba-custos-recursos-outros-custos-form-modal.component.scss']
})
export class OsaExecucaoAbaCustosRecursosOutrosCustosFormModalComponent extends BaseFormComponent implements OnInit {

  public modelOsaExecucaoCustoRecurso!: any;

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    private dialogRef: MatDialogRef<OsaExecucaoAbaCustosRecursosOutrosCustosFormModalComponent>,
    public matDialog: MatDialog,
    private osaExecucaoCustoRecursoService: OsaExecucaoCustoRecursoService,
    private custoRecursoService: CustoRecursoService,

    @Inject(MAT_DIALOG_DATA) private data) {
    super(route, toastr, router, localeService, matDialog);
    this.modelOsaExecucaoCustoRecurso = this.data;
  }

  ngOnInit(): void {

    if (this.data.id > 0) {
      this.titulo = 'Edição Custo e Recurso'
    }
    else {
      this.titulo = 'Inclusão Custo e Recurso'
    }
  }

  formatarInput(value) {
    return toFormatValue(value);
  }

  public async exibirModalCustoRecurso() {
    try {
      const res = await this.custoRecursoService.obter('', true);
      if (res.sucesso) {
        const dadosFiltrados = res.dados.filter(constatacao => constatacao.ativo);
        const modal = this.exibirModal('Selecionar custo e recurso ', dadosFiltrados, true, null, null, null, 'modal-component-custos-recursos');
        modal.afterClosed().subscribe(data => {
          if (data) {
            // this.modelCustoRecursoPlanejamento.id = data.id;
            this.modelOsaExecucaoCustoRecurso.nome = data.nome;
            this.modelOsaExecucaoCustoRecurso.valorUnitario = data.valorMedio;
          }
        }
        );
      } else {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    } catch (err) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        text: err.mensagem.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }

  onInputValor(event: any): void {
    const input = event.target as HTMLInputElement;
    const valor = input.value;

    // Permite apenas números (remove tudo que não é número)
    const numerosSomente = valor.replace(/\D/g, '');

    if (numerosSomente === '') {
      this.modelOsaExecucaoCustoRecurso.valorUnitario = 0;
      input.value = '';
      return;
    }

    const float = parseFloat(numerosSomente) / 100;
    this.modelOsaExecucaoCustoRecurso.valorUnitario = float;
    input.value = this.formatarValorVisual(float);
  }

  ajustarVisualizacao(): void {
    // Força ajuste ao sair do campo
    if (isNaN(this.modelOsaExecucaoCustoRecurso.valorUnitario)) {
      this.modelOsaExecucaoCustoRecurso.valorUnitario = 0;
    }
  }

  formatarValorVisual(valor: number): string {
    if (valor == null || isNaN(valor)) {
      return '';
    }

    return valor.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
    });
  }

  public salvar(fechar: boolean) {

    if (this.modelOsaExecucaoCustoRecurso) {
      const dados = this.modelOsaExecucaoCustoRecurso

      const request$ = dados.id && dados.id > 0
        ? this.osaExecucaoCustoRecursoService.atualizar(dados)
        : this.osaExecucaoCustoRecursoService.inserir(dados)

      request$.subscribe({
        next: (res) => {
          if (res.sucesso) {
            this.modelOsaExecucaoCustoRecurso = res.dados;
            this.toastr.success('Registro salvo com sucesso!');
            if (fechar) {
              this.dialogRef.close(true);
            }
          } else {
            this.exibirMensagemErro(res.mensagem?.descricao || 'Erro ao salvar');
          }
        },
        error: (err) => this.exibirMensagemErro(err)
      });
    }
  }

  public cancelar() {
    this.dialogRef.close(true);
  }
}